jQuery(function ($) {
  "use strict";

  $(document).on("click", ".js-faq-trigger", function () {
    const $btn = $(this);
    const $content = $btn.next(".js-faq-content");
    const isOpen = $btn.attr("aria-expanded") === "true";

    if (isOpen) {
      // 閉じる
      $btn.attr("aria-expanded", "false");
      $content.removeClass("is-open").css("max-height", 0);
    } else {
      // 開く
      $btn.attr("aria-expanded", "true");
      $content.addClass("is-open");

      const height = $content[0].scrollHeight;
      $content.css("max-height", height + "px");
    }
  });
});
